import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";

class _CrazyGamesSDK {
    private _sdk: any;

    init() {
        //@ts-ignore
        this._sdk = window.CrazyGames.CrazySDK.getInstance();
        this._sdk.init();
        this.addListeners(() => {
            console.log("CRAZY GAMES AD STARTED");
            this._mute();
        }, () => {
            console.log("CRAZY GAMES AD FINISHED");
            this._unmute();
        }, () => {
            console.log("CRAZY GAMES AD FAILED");
            this._unmute();
        });
    }



    private _mute() {
        AudioManager.sound.mute(true);
        AudioManager.music.mute(true);
    }

    private _unmute() {
        if (AudioManager.sound) {
            AudioManager.sound.mute(GameVars.gameData.soundMuted);
        }

        if (AudioManager.music) {
            AudioManager.music.mute(GameVars.gameData.musicMuted);
        }
    }

    addListeners(started: Function, finished: Function, failed: Function) {
        this._sdk.addEventListener('adStarted', started);
        this._sdk.addEventListener('adFinished', finished);
        this._sdk.addEventListener('adError', failed);
    }

    removeListeners(started: Function, finished: Function, failed: Function) {
        this._sdk.removeEventListener('adStarted', started);
        this._sdk.removeEventListener('adFinished', finished);
        this._sdk.removeEventListener('adError', failed);
    }

    requestAd(s: "midgame" | "rewarded") {
        this._sdk.requestAd(s);
    }

    happyTime() {
        this._sdk.happytime();
    }
    gameplayStart() {
        this._sdk.gameplayStart();
    }
    gameplayStop() {
        this._sdk.gameplayStop();
    }
}

export const CrazyGamesSDK = new _CrazyGamesSDK();